// Run this example by adding <%= javascript_pack_tag 'hello_react' %> to the head of your layout file,
// like app/views/layouts/application.html.erb. All it does is render <div>Hello React</div> at the bottom
// of the page.

import React, { useCallback, useMemo, useState } from 'react';
import { Add, Menu } from '@material-ui/icons';
import classnames from 'classnames';

import './PageSubNav.css';
import { anchorIsNakedNewsLive } from '../../utils/helpers';


function PageSubnav(props) {
  const {
    isNNLivePage,
    typeOfListing,
    handleClick,
    featureExists,
    subscribedToAnchor,
    itemCount,
    id,
    showClipStore,
    showFanZone,
    showPageSubNav,
  } = props;
  const [isLinksVisible, setIsLinkVisible] = useState(false);

  const getPageSubnavLinks = useCallback(() => {
    const isNNLive = anchorIsNakedNewsLive(id);
    let features = ['segments', 'audition'];

    if (itemCount > 0) {
      if (!subscribedToAnchor && parseInt(id, 10) === 120) {
        features = ['segments', 'audition'];
      } else {
        if ((showFanZone) || isNNLive) {
          features.unshift('fan zone');
        }
        if (showClipStore || isNNLive) {
          features.push('clipstore');
        }
      }
    }

    const pageSubnavLinks = [];
    features.forEach((feature) => {
      if (feature === 'clipstore' && featureExists[feature.replace(/\s/g, '')] && showClipStore) {
        pageSubnavLinks.push('Clip Store');
      } else if (feature === 'fan zone' && featureExists[feature.replace(/\s/g, '')] && showFanZone) {
        pageSubnavLinks.unshift('fan zone');
      } else if (feature === 'fan zone' && featureExists[feature.replace(/\s/g, '')] && isNNLive) {
        pageSubnavLinks.push('galleries & videos');
      } else if (featureExists[feature.replace(/\s/g, '')] && feature !== 'clipstore') {
        pageSubnavLinks.push(feature.toUpperCase());
      }
    });

    return pageSubnavLinks;
  }, [featureExists, id, itemCount, showClipStore, showFanZone, subscribedToAnchor]);

  const toggleLinks = useCallback(() => {
    setIsLinkVisible(isLinksVisible);
  }, [isLinksVisible]);
  const links = useMemo(() => getPageSubnavLinks(), [getPageSubnavLinks]);

  const renderNavLinks = useMemo(() => (
    <ul className="nav navbar-nav">
      {links.map((link) => {
        const linkToLowercase = link.toLowerCase().replace(/\s/g, '');
        const isLinkActive = (linkToLowercase === typeOfListing) ||
          (linkToLowercase === 'galleries&videos' && typeOfListing === 'fanzone');

        return (
          <React.Fragment key={link}>
            <li
              className={
                classnames('nav-item &#147;false', { 'active': isLinkActive })
              }
            >
              {isLinkActive && <Add />}
              <a
                key={link}
                data-index="0"
                href="/"
                onClick={handleClick}
              >
                {link}
              </a>
            </li>
          </React.Fragment>
        );
      })}
    </ul>
  ), [handleClick, links, typeOfListing]);

  if (!showPageSubNav) {
    return null;
  }

  return (
    <div
      className={classnames('content white page-sub-nav', { 'nnlive': isNNLivePage })}
    >
      <div className="container">
        <div className="page-subnav-container">
          <nav
            className="center navbar page-subnav"
            role="navigation"
          >
            <div className="navbar-header">
              <button
                className="collapsed navbar-toggle"
                data-target="#page-subnav"
                data-toggle="collapse"
                onClick={toggleLinks}
              >
                <Menu fontSize="inherit" />
              </button>
            </div>
            <div
              className={classnames(
                'collapse navbar-collapse',
                { 'in': isLinksVisible }
              )}
              id="page-subnav"
            >
              {renderNavLinks}
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
}

export default PageSubnav;
